import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'

type Props = {
  name: string
  beforeName: React.ReactNode
  afterName: React.ReactNode
}

export const WalletNameCell: React.FC<Props> = (props: Props) => {
  const { name, beforeName, afterName } = props
  return (
    <Root>
      {beforeName}
      <Name ellipsis>{name}</Name>
      {afterName}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 3px;
  align-items: center;
`
const Name = styled(Typography)`
  color: var(--text-12);

  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`
